import { useTranslation } from 'react-i18next'

import { EditRankingForm } from './EditForm'
import RankingWidget from '../RankingWidget'

export const useRANKING_CONFIG = () => {
  const { t } = useTranslation('common')

  return {
    id: 'RANKING',
    name: t('widgets.ranking.name'),
    description: t('widgets.ranking.description'),
    icon: 'RiListOrdered',
    previewWidth: '100%',

    initialState: {
      size: { width: 100, height: 700 },
      data: { perspective: 'user' }
    },

    Presentation: RankingWidget,
    Form: EditRankingForm
  }
}

export const useUSERS_RANKING_CONFIG = () => {
  const { t } = useTranslation('common')
  const base = useRANKING_CONFIG()

  return {
    ...base,
    name: t('widgets.usersRanking.name'),
    color: 'cyan',
    categories: [t('widgets.usersRanking.category')],
    data: { ...base.data, perspective: 'user' }
  }
}

export const usePLACES_RANKING_CONFIG = () => {
  const { t } = useTranslation('common')
  const base = useRANKING_CONFIG()

  return {
    ...base,
    name: t('widgets.placesRanking.name'),
    color: 'dark2',
    categories: [t('widgets.placesRanking.category')],
    data: { ...base.data, perspective: 'place' }
  }
}

export const useCHECKLISTS_RANKING_CONFIG = () => {
  const { t } = useTranslation('common')
  const base = useRANKING_CONFIG()

  return {
    ...base,
    name: t('widgets.checklistsRanking.name'),
    color: 'light5',
    categories: [t('widgets.checklistsRanking.category')],
    data: { ...base.data, perspective: 'checklist' }
  }
}
